import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Person } from '../../state/people';

@Injectable({
  providedIn: 'root'
})
export class FormatService {

  constructor() {
  }

  formatDate(dateOfBirth) {
    return dateOfBirth ? moment(dateOfBirth).format('ll') : 'N/A';
  }

  formatBoolean(field): string {
    return field != undefined ? (field ? 'Ja' : 'Nee') : 'N/A';
  };

  formatMoney(field) {
    return field ? this.formatEuro(field) : 'N/A';
  }

  formatEuroInWords(amount: string): any {
    return 'EUR: ' + this.formatNumber(amount);
  }

  formatEuro(amount: string): any {
    return new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR'})
      .format(parseFloat(amount));
  }

  formatNumber(amount) {
    return Number(amount).toLocaleString('nl-NL', {minimumFractionDigits: 2});
  }

  formatPersonName(model: Person) {
    if (!model) {
      return 'Unknown';
    }
    if (model.middle_name) {
      return model.first_name + ' ' + model.middle_name + ' ' + model.last_name;
    } else {
      return model.first_name + ' ' + model.last_name;
    }
  }

  formatAddress(address) {
    return address ?
           `${address.address} ${address.city} ${address.country.name}`
                   : 'N/A';
  }
}
